module.exports = "App.Collections.ContactOrganizations = Backbone.Collection.extend({\n\n  model: App.Models.ContactOrganization\n\n});\n"